

import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  TextField, 
  Button, 
  Box, 
  List, 
  ListItem, 
  ListItemText, 
  Paper, 
  Popper, 
  ClickAwayListener, 
  CircularProgress,
  IconButton,
  Container,
  Typography,
  Card,
  CardContent
} from "@mui/material";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { toast } from 'react-toastify';
import BusSearchDown from "./BusSearchDown.jsx";

export default function BusSearch({initialSearchData}) {
  const getTomorrowDate = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().split("T")[0];
};
  const navigate = useNavigate();
const [searchData, setSearchData] = useState({
  from: '',
  to: '',
  date: getTomorrowDate()
});



  const [fromData, setFromData] = useState({
    id: '',
    name: ''
  });
  const [toData, setToData] = useState({
    id: '',
    name: ''
  });
  
  const [suggestions, setSuggestions] = useState({
    from: [],
    to: []
  });
  const [openDropdown, setOpenDropdown] = useState({
    from: false,
    to: false
  });
  const [loading, setLoading] = useState({
    from: false,
    to: false
  });
  const [searching, setSearching] = useState(false);



  useEffect(() => {
  if (!initialSearchData) return;

  setSearchData({
    from: initialSearchData.from.name || '',
    to: initialSearchData.to.name || '',
    date: initialSearchData.date || getTomorrowDate()
  });

  // If IDs are provided (important!)
  if (initialSearchData.from.id) {
    setFromData({
      id: initialSearchData.from.id,
      name: initialSearchData.from.name
    });
  }

  if (initialSearchData.to.id) {
    setToData({
      id: initialSearchData.to.id,
      name: initialSearchData.to.name
    });
  }
}, [initialSearchData]);
  const fromInputRef = useRef(null);
  const toInputRef = useRef(null);
  const debounceTimeout = useRef(null);
  const accessToken = localStorage.getItem("accessToken");
console.log("accessToken : ",accessToken)
  // API call function for autocomplete with "term" parameter
  const fetchSuggestions = async (query, type) => {
    if (!query || query.trim().length < 2) {
      setSuggestions(prev => ({ ...prev, [type]: [] }));
      return;
    }

    setLoading(prev => ({ ...prev, [type]: true }));
    
    try {
      const formData = new FormData();
      formData.append('term', query);
console.log("accessToken .......... : ",accessToken)
      const response = await fetch('https://admin.jayrajgroup.com/api/bus/autocomplete', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json",
        },
        body: formData
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log("data ????????????? ",data)
      if (data.status) {
        setSuggestions(prev => ({ 
          ...prev, 
          [type]: data.data || []
        }));
        console.log("data ????????????? ",data)
        // toast.success(`Found ${data.data?.length || 0} suggestions`);
      } else {
        setSuggestions(prev => ({ ...prev, [type]: [] }));
        // toast.warning("No results found");
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      setSuggestions(prev => ({ ...prev, [type]: [] }));
      // Optional: Show error toast
    } finally {
      setLoading(prev => ({ ...prev, [type]: false }));
    }
  };

  // Alternative JSON version if needed
  const fetchSuggestionsJSON = async (query, type) => {
    if (!query || query.trim().length < 2) {
      setSuggestions(prev => ({ ...prev, [type]: [] }));
      return;
    }

    setLoading(prev => ({ ...prev, [type]: true }));
    
    try {
      const response = await fetch('https://admin.jayrajgroup.com/api/bus/autocomplete', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json",
          'Content-Type': 'application/json'
        },
      
        body: JSON.stringify({ term: query })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.status) {
        setSuggestions(prev => ({ 
          ...prev, 
          [type]: data.data || []
        }));
      } else {
        setSuggestions(prev => ({ ...prev, [type]: [] }));
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      setSuggestions(prev => ({ ...prev, [type]: [] }));
    } finally {
      setLoading(prev => ({ ...prev, [type]: false }));
    }
  };

  // Bus search API call
const searchBuses = async () => {
  setSearching(true);
  
  try {
    const formData = new FormData();
    formData.append('origin_id', fromData.id);
    formData.append('destination_id', toData.id);
    // formData.append('origin_id', 8463);
    // formData.append('destination_id', 9573);
    formData.append('depart_date', searchData.date);

    console.log("Sending Data:", Object.fromEntries(formData));

    const response = await fetch('https://admin.jayrajgroup.com/api/bus/bus-search', {
      method: 'POST',
      headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json",
        },
      body: formData,
    });
    
    const data = await response.json();
    console.log("data ...............: ",data)
    if (data.status) {
      toast.success(`Found ${data.data?.BusSearchResult?.BusResults?.length || 0} suggestions`);
      navigate('/bus-results', {
        state: {
          searchData: {
            from: fromData,
            to: toData,
            date: searchData.date
          },
          busResults: data.data || []
        }
      });
    } else {
      alert(data.message || 'No buses found for this route');
    }
  } catch (error) {
    console.error('Error searching buses:', error);
    alert('Failed to search buses. Please check your connection.');
  } finally {
    setSearching(false);
  }
};

  const handleInputChange = (field) => async (event) => {
    const value = event.target.value;
    
    setSearchData(prev => ({
      ...prev,
      [field]: value
    }));

    if (field === 'from') {
      setFromData({ id: '', name: '' });
    } else if (field === 'to') { 
      setToData({ id: '', name: '' });
    }

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    if (field !== 'date') {
      debounceTimeout.current = setTimeout(async () => {
        if (value.length >= 2) {
          setOpenDropdown(prev => ({ ...prev, [field]: true }));
          await fetchSuggestions(value, field);
        } else {
          setOpenDropdown(prev => ({ ...prev, [field]: false }));
          setSuggestions(prev => ({ ...prev, [field]: [] }));
        }
      }, 300);
    }
  };

const handleSuggestionClick = (type, item) => {
  const selectedId = item.CityId || item.id || '';
  const selectedName = item.CityName || item.name || '';

  setSearchData(prev => ({
    ...prev,
    [type]: selectedName
  }));
  
  if (type === 'from') {
    setFromData({ id: selectedId, name: selectedName });
  } else {
    setToData({ id: selectedId, name: selectedName });
  }
  
  setOpenDropdown(prev => ({ ...prev, [type]: false }));
};

  const handleSearch = async () => {
   
    // if (fromData.id === toData.id) {
    //   alert('From and To locations cannot be the same');
    //   return;
    // }

    // Call bus search API
    await searchBuses();
  };

  const handleClickAway = (type) => {
    setOpenDropdown(prev => ({ ...prev, [type]: false }));
  };

  const handleSwapLocations = () => {
    // Swap search text
    setSearchData(prev => ({
      ...prev,
      from: prev.to,
      to: prev.from
    }));
    
    // Swap selected data
    const tempFrom = { ...fromData };
    setFromData({ ...toData });
    setToData(tempFrom);
    
    // Clear suggestions
    setSuggestions({
      from: [],
      to: []
    });
    setOpenDropdown({
      from: false,
      to: false
    });
  };

  // Clear timeout on component unmount
  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  // Handle keyboard navigation
  const handleKeyDown = (field, event) => {
    if (event.key === 'Escape') {
      setOpenDropdown(prev => ({ ...prev, [field]: false }));
    }
    if (event.key === 'Enter' && field === 'from' && toInputRef.current) {
      toInputRef.current.focus();
    }
    if (event.key === 'Enter' && field === 'to' && fromData.id && toData.id) {
      handleSearch();
    }
  };

  // Helper function to extract display info from suggestion item
  const getSuggestionInfo = (item) => {
    return {
      id: item.CityId || item.id || item.value || '',
      name: item.CityName || item.name || item.label || '',
      category: item.category || item.type || '',
      searchType: item.search_type || ''
    };
  };

  return (

    <>
        <Container maxWidth="lg" >
      <Card elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', background: 'linear-gradient(135deg, #d4af37, #ffd700)' }}>
        <CardContent sx={{ }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
            Search Buses
          </Typography>
          
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'flex-end', 
            gap: 2, 
            position: 'relative',
            flexWrap: { xs: 'wrap', md: 'nowrap' }
          }}>
            {/* From Field with Dropdown */}
            <Box sx={{ flex: { xs: '1 0 100%', md: 1.5 }, position: 'relative', minWidth: 200 }}>
              <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block', fontWeight: 'medium' }}>
                From
              </Typography>
              <ClickAwayListener onClickAway={() => handleClickAway('from')}>
                <Box>
                  <TextField
                    inputRef={fromInputRef}
                    value={searchData.from}
                    onChange={handleInputChange('from')}
                    onKeyDown={(e) => handleKeyDown('from', e)}
                    placeholder="Enter origin city"
                    fullWidth
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    InputProps={{
                      endAdornment: loading.from ? (
                        <CircularProgress size={20} />
                      ) : null
                    }}
                  />
                  {openDropdown.from && (
                    <Popper
                      open={openDropdown.from}
                      anchorEl={fromInputRef.current}
                      placement="bottom-start"
                      style={{ 
                        width: fromInputRef.current ? fromInputRef.current.clientWidth : 'auto', 
                        zIndex: 1300,
                        marginTop: '4px'
                      }}
                    >
                      <Paper
                        elevation={3}
                        sx={{
                          width: '100%',
                          maxHeight: 300,
                          overflow: 'auto',
                          border: '1px solid',
                          borderColor: 'divider',
                          borderRadius: 1
                        }}
                      >
                        {loading.from ? (
                          <Box sx={{ 
                            p: 2, 
                            textAlign: 'center', 
                            color: 'text.secondary',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1
                          }}>
                            <CircularProgress size={16} />
                            Searching...
                          </Box>
                        ) : suggestions.from.length > 0 ? (
                          <List dense disablePadding>
                            {suggestions.from.map((item, index) => {
                              const info = getSuggestionInfo(item);
                              return (
                                <ListItem
                                  key={`${info.id}-${index}`}
                                  button
                                  onClick={() => handleSuggestionClick('from', item)}
                                  sx={{
                                    '&:hover': {
                                      backgroundColor: 'action.hover'
                                    },
                                    px: 2,
                                    py: 1.5,
                                    borderBottom: index !== suggestions.from.length - 1 ? '1px solid' : 'none',
                                    borderColor: 'divider'
                                  }}
                                >
                                  <ListItemText 
                                    primary={info.name}
                                    primaryTypographyProps={{
                                      fontWeight: 'medium',
                                      fontSize: '0.95rem'
                                    }}
                                   
                                    secondaryTypographyProps={{
                                      fontSize: '0.75rem',
                                      color: 'text.secondary'
                                    }}
                                  />
                                </ListItem>
                              );
                            })}
                          </List>
                        ) : searchData.from.length >= 2 ? (
                          <Box sx={{ 
                            p: 3, 
                            textAlign: 'center', 
                            color: 'text.secondary',
                            fontStyle: 'italic'
                          }}>
                            No locations found for "{searchData.from}"
                          </Box>
                        ) : null}
                      </Paper>
                    </Popper>
                  )}
                </Box>
              </ClickAwayListener>
            </Box>

            {/* Swap Button */}
            <Box sx={{ 
              alignSelf: 'center', 
              mb: 0.5,
              display: { xs: 'none', md: 'block' }
            }}>
              <IconButton
                onClick={handleSwapLocations}
                sx={{
                  backgroundColor: 'action.hover',
                  '&:hover': {
                    backgroundColor: 'action.selected',
                    transform: 'rotate(180deg)',
                    transition: 'transform 0.3s'
                  }
                }}
              >
                <SwapHorizIcon />
              </IconButton>
            </Box>

            {/* Mobile swap button */}
            <Box sx={{ 
              alignSelf: 'center', 
              mb: 0.5,
              display: { xs: 'block', md: 'none' },
              width: '100%',
              textAlign: 'center'
            }}>
              <Button
                onClick={handleSwapLocations}
                startIcon={<SwapHorizIcon />}
                size="small"
                sx={{ textTransform: 'none' }}
              >
                Swap Locations
              </Button>
            </Box>

            {/* To Field with Dropdown */}
            <Box sx={{ flex: { xs: '1 0 100%', md: 1.5 }, position: 'relative', minWidth: 200 }}>
              <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block', fontWeight: 'medium' }}>
                To
              </Typography>
              <ClickAwayListener onClickAway={() => handleClickAway('to')}>
                <Box>
                  <TextField
                    inputRef={toInputRef}
                    value={searchData.to}
                    onChange={handleInputChange('to')}
                    onKeyDown={(e) => handleKeyDown('to', e)}
                    placeholder="Enter destination city"
                    fullWidth
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    InputProps={{
                      endAdornment: loading.to ? (
                        <CircularProgress size={20} />
                      ) : null
                    }}
                  />
                  {openDropdown.to && (
                    <Popper
                      open={openDropdown.to}
                      anchorEl={toInputRef.current}
                      placement="bottom-start"
                      style={{ 
                        width: toInputRef.current ? toInputRef.current.clientWidth : 'auto', 
                        zIndex: 1300,
                        marginTop: '4px'
                      }}
                    >
                      <Paper
                        elevation={3}
                        sx={{
                          width: '100%',
                          maxHeight: 300,
                          overflow: 'auto',
                          border: '1px solid',
                          borderColor: 'divider',
                          borderRadius: 1
                        }}
                      >
                        {loading.to ? (
                          <Box sx={{ 
                            p: 2, 
                            textAlign: 'center', 
                            color: 'text.secondary',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1
                          }}>
                            <CircularProgress size={16} />
                            Searching...
                          </Box>
                        ) : suggestions.to.length > 0 ? (
                          <List dense disablePadding>
                            {suggestions.to.map((item, index) => {
                              const info = getSuggestionInfo(item);
                              return (
                                <ListItem
                                  key={`${info.id}-${index}`}
                                  button
                                  onClick={() => handleSuggestionClick('to', item)}
                                  sx={{
                                    '&:hover': {
                                      backgroundColor: 'action.hover'
                                    },
                                    px: 2,
                                    py: 1.5,
                                    borderBottom: index !== suggestions.to.length - 1 ? '1px solid' : 'none',
                                    borderColor: 'divider'
                                  }}
                                >
                                  <ListItemText 
                                    primary={info.name}
                                    primaryTypographyProps={{
                                      fontWeight: 'medium',
                                      fontSize: '0.95rem'
                                    }}

                                    secondaryTypographyProps={{
                                      fontSize: '0.75rem',
                                      color: 'text.secondary'
                                    }}
                                  />
                                </ListItem>
                              );
                            })}
                          </List>
                        ) : searchData.to.length >= 2 ? (
                          <Box sx={{ 
                            p: 3, 
                            textAlign: 'center', 
                            color: 'text.secondary',
                            fontStyle: 'italic'
                          }}>
                            No locations found for "{searchData.to}"
                          </Box>
                        ) : null}
                      </Paper>
                    </Popper>
                  )}
                </Box>
              </ClickAwayListener>
            </Box>

            {/* Date Field */}
            <Box sx={{ flex: { xs: '1 0 100%', md: 1 }, position: 'relative', minWidth: 180 }}>
              <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block', fontWeight: 'medium' }}>
                Departure Date
              </Typography>
              <TextField
                type="date"
                value={searchData.date}
                onChange={handleInputChange('date')}
                fullWidth
                variant="outlined"
                size="small"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: new Date().toISOString().split('T')[0],
                  style: {
                    color: 'text.primary',
                    padding: '8.5px 14px',
                    cursor: 'pointer'
                  }
                }}
              />
            </Box>

            {/* Search Button */}
            <Box sx={{ flex: { xs: '1 0 100%', md: 1 }, minWidth: 120 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSearch}
                // disabled={!fromData.id || !toData.id || searching}
                fullWidth
                size="large"
                sx={{
                  height: 40,
                  textTransform: 'none',
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderRadius: 1,
                  '&:disabled': {
                    backgroundColor: 'action.disabled',
                    color: 'action.disabled'
                  },
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4,
                    transform: 'translateY(-1px)',
                    transition: 'all 0.2s'
                  }
                }}
              >
                {searching ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Search Buses'
                )}
              </Button>
            </Box>
          </Box>

        
        </CardContent>
      </Card>
      
    </Container>
   
    </>

  );
}